import { render, staticRenderFns } from "./FaceStyleDetection.vue?vue&type=template&id=604da046&scoped=true&"
import script from "./FaceStyleDetection.vue?vue&type=script&lang=js&"
export * from "./FaceStyleDetection.vue?vue&type=script&lang=js&"
import style0 from "./FaceStyleDetection.vue?vue&type=style&index=0&id=604da046&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604da046",
  null
  
)

export default component.exports